import React from "react";
import { useKeycloak } from "@react-keycloak/web";
import { appserveraddr } from "../../../Services/EndPoints";
import "./Signout.css";
import { Logout } from "../../../Components/IconComponents";
const Signout = ({ label = "Sign Out" }) => {
  const { keycloak } = useKeycloak();

  const signoutHandler = () => {
    localStorage.clear();
    keycloak.logout({ redirectUri: appserveraddr });
  };

  return (
    <div
      className="signout_text cursor-pointer"
      onClick={signoutHandler}
      name="Signout"
    >
      {/* {label} */}
      <Logout />
    </div>
  );
};

export default Signout;
